export default {
  translation: {
    nav: {
      home: 'Trang chủ',
      trips: 'Chuyến đi',
      aboutUs: 'Về chúng tôi',
      alerts: 'Thông báo',
      wishlist: 'Yêu thích',
      language: 'Ngôn ngữ',
      profile: 'Hồ sơ',
      settings: 'Cài đặt',
      signIn: 'Đăng nhập',
      signUp: 'Đăng ký'
    },
    hero: {
      title: 'Khám phá Uganda',
      subtitle: 'và hơn thế nữa',
      description: 'Khám phá Viên ngọc của Châu Phi cùng các hướng dẫn viên địa phương chuyên nghiệp. Những trải nghiệm khó quên đang chờ đợi bạn trong cảnh quan tuyệt đẹp và văn hóa sống động của Uganda.',
      searchPlaceholder: 'Bạn muốn đi đâu?',
      categories: {
        all: 'Tất cả',
        wildlife: 'Động vật hoang dã',
        safari: 'Safari',
        cultural: 'Văn hóa',
        adventure: 'Phiêu lưu',
        birding: 'Ngắm chim'
      }
    },
    common: {
      from: 'từ',
      reviews: 'đánh giá',
      viewMore: 'Xem thêm',
      book: 'Đặt ngay',
      seeAll: 'Xem tất cả',
      loading: 'Đang tải...'
    }
  }
};